window.addEventListener('load', function () {
  var form = document.querySelector('form#contact_form.contact-form--wizard');
  if (!form) return;

  // DOM references
  var subjectEl       = document.getElementById('contact_subject');
  var detailsStep     = form.querySelector('.cf-step[data-step="2"]');
  var successBox      = document.getElementById('cfFormSuccess');
  var faqTitle        = form.querySelector('.cf-subquestions .page__title');
  var detailsTextarea = form.querySelector('textarea[name="contact[body]"]');
  var summaryEl       = form.querySelector('.cf-summary');
  var issueGroups     = form.querySelectorAll('.cf-issue-group');
  var faqSearchInput  = form.querySelector('.cf-faq-search-input');
  var attachContainer = form.querySelector('.cf-attachments');
  var emailConfirm = form.querySelector('input[name="contact[email_confirm]"]');
  var emailInput = form.querySelector('input[name="contact[email]"]');
  var deliveredChecksBlock = form.querySelector('.cf-delivered-no-parcel-checks');
  var orderNumberInput = form.querySelector('input[name="contact[order_number]"]');
  var productNameInput   = form.querySelector('input[name="contact[product_name]"]');
  var productSerialInput = form.querySelector('input[name="contact[product_serial]"]');
  var faultTimingSelect = form.querySelector('select[name="contact[fault_timing]"]');
  var productNameBlock   = form.querySelector('.cf-extra--product_name');
  var productSerialBlock = form.querySelector('.cf-extra--product_serial');
  var faultTimingBlock   = form.querySelector('.cf-extra--fault_timing');
  var returnReasonBlock  = form.querySelector('.cf-extra--return_reason');
  var returnReasonSelect = form.querySelector('select[name="contact[return_reason]"]');
  var addressChangeBlock = form.querySelector('.cf-extra--delivery_address_change');
  var updatedAddress1 = form.querySelector('input[name="contact[updated_address_line1]"]');
  var updatedCity     = form.querySelector('input[name="contact[updated_city]"]');
  var updatedPostcode = form.querySelector('input[name="contact[updated_postcode]"]');


  function setAttachmentsMode(mode, customTitle) {
  // mode: 'hide' | 'optional' | 'required'
  if (!attachContainer) return;

  var title = attachContainer.querySelector('.cf-attach-title');
  var addBtn = attachContainer.querySelector('.cf-add-more-files');
  var inputsWrap = attachContainer.querySelector('.cf-attach-inputs');
  var firstInput = attachContainer.querySelector('input[type="file"]');

  // Clear existing file selections + previews when switching modes
  var preview = attachContainer.querySelector('.cf-attach-preview');
  if (preview) preview.innerHTML = '';
  attachContainer.querySelectorAll('input[type="file"]').forEach(function (fi, idx) {
    if (idx === 0) {
      fi.value = '';
    } else {
      fi.remove();
    }
  });

  if (mode === 'hide') {
    attachContainer.classList.add('cf-hidden');
    if (firstInput) firstInput.removeAttribute('required');
    return;
  }

  attachContainer.classList.remove('cf-hidden');

  // Only override the label when a customTitle is passed (so we don't affect other attachment uses)
  if (title && typeof customTitle === 'string' && customTitle.trim()) {
    title.textContent = customTitle;
  }

  if (firstInput) {
    if (mode === 'required') firstInput.setAttribute('required', 'required');
    else firstInput.removeAttribute('required');
  }

  if (addBtn) addBtn.style.display = '';
  if (inputsWrap) inputsWrap.style.display = '';
}

function syncEmailConfirmValidity() {
  if (!emailInput || !emailConfirm) return;

  var emailVal = (emailInput.value || '').trim().toLowerCase();
  var confirmVal = (emailConfirm.value || '').trim().toLowerCase();

  if (!confirmVal) {
    emailConfirm.setCustomValidity('');
    return;
  }

  if (emailVal !== confirmVal) {
    emailConfirm.setCustomValidity('Your email addresses don’t match.');
  } else {
    emailConfirm.setCustomValidity('');
  }
}

function syncConditionalFieldSubmission() {
  if (!form) return;

  // Any field inside a hidden conditional block should not be submitted
  form.querySelectorAll('.cf-extra, .cf-delivered-no-parcel-checks, .cf-attachments').forEach(function (block) {
    var isHidden = block.classList.contains('cf-hidden');

    block.querySelectorAll('input, select, textarea').forEach(function (field) {
      // Never disable the main message/body field if it happens to be matched in future
      if (field.name === 'contact[body]') return;

      if (isHidden) {
        field.disabled = true;
      } else {
        field.disabled = false;
      }
    });
  });

  // Only the active issue group's hidden input should submit
  form.querySelectorAll('.cf-issue-group').forEach(function (group) {
    var hiddenIssueInput = group.querySelector('input[type="hidden"]');
    if (!hiddenIssueInput) return;

    if (group.classList.contains('cf-hidden')) {
      hiddenIssueInput.disabled = true;
    } else {
      hiddenIssueInput.disabled = false;
    }
  });
}

function syncUploadedAttachmentFields(files) {

  // Remove old generated attachment fields
  form.querySelectorAll('input[data-uploaded-attachment="true"]').forEach(function (el) {
    el.remove();
  });

  if (!files || !files.length) return;

  files.forEach(function (file, idx) {

    var number = idx + 1;

    var urlField = document.createElement('input');
    urlField.type = 'hidden';
    urlField.name = 'contact[Upload File ' + number + ']';
    urlField.value = file.url || '';
    urlField.setAttribute('data-uploaded-attachment', 'true');
    form.appendChild(urlField);

    var nameField = document.createElement('input');
    nameField.type = 'hidden';
    nameField.name = 'contact[File Name ' + number + ']';
    nameField.value = file.name || '';
    nameField.setAttribute('data-uploaded-attachment', 'true');
    form.appendChild(nameField);

  });

}

function compressImageFile(file) {
  return new Promise(function (resolve) {
    // Only compress image files
    if (!file || !file.type || file.type.indexOf('image/') !== 0) {
      resolve(file);
      return;
    }

    // Don't try to compress GIFs
    if (file.type === 'image/gif') {
      resolve(file);
      return;
    }

    var reader = new FileReader();

    reader.onload = function (evt) {
      var img = new Image();

      img.onload = function () {
        var maxWidth = 1600;
        var maxHeight = 1600;
        var width = img.width;
        var height = img.height;

        if (width > maxWidth || height > maxHeight) {
          var ratio = Math.min(maxWidth / width, maxHeight / height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }

        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        var ctx = canvas.getContext('2d');
        if (!ctx) {
          resolve(file);
          return;
        }

        ctx.drawImage(img, 0, 0, width, height);

        var outputType = 'image/jpeg';
        if (file.type === 'image/png' || file.type === 'image/webp') {
          outputType = file.type;
        }

        var quality = 0.8;

        canvas.toBlob(function (blob) {
          if (!blob) {
            resolve(file);
            return;
          }

          // If compression made it bigger, keep original
          if (blob.size >= file.size) {
            resolve(file);
            return;
          }

          var compressedFile = new File(
            [blob],
            file.name,
            {
              type: outputType,
              lastModified: Date.now()
            }
          );

          resolve(compressedFile);
        }, outputType, quality);
      };

      img.onerror = function () {
        resolve(file);
      };

      img.src = evt.target.result;
    };

    reader.onerror = function () {
      resolve(file);
    };

    reader.readAsDataURL(file);
  });
}

  // State
  var chosenReason        = null;
  var currentCategory     = null;
  var highlightedFaqBtn   = null;
  var highlightedFaqPanel = null;
  var isUploadingAttachments = false;

  function resetSubmitLock() {
  isUploadingAttachments = false;

  var submitBtn = form.querySelector('.cf-submit');
  if (submitBtn) {
    submitBtn.disabled = false;
    submitBtn.textContent = 'Send message';
  }
}

// =====================================================
// Deep linking (hc_cat, hc_issue, hc_faq)
// =====================================================
var isApplyingDeepLink = false;

function readDeepLink() {
  var sp = new URLSearchParams(window.location.search);
  return {
    cat:   (sp.get('hc') || '').trim(),
    issue: (sp.get('i')  || '').trim(),
    faq:   (sp.get('f')  || '').trim()
  };
}

function writeDeepLink(next, mode) {
  var url = new URL(window.location.href);
  var sp = url.searchParams;

  if (next.cat)   sp.set('hc', next.cat);   else sp.delete('hc');
  if (next.issue) sp.set('i',  next.issue); else sp.delete('i');
  if (next.faq)   sp.set('f',  next.faq);   else sp.delete('f');

  url.search = sp.toString();

  if (mode === 'replace') {
    window.history.replaceState({}, '', url.toString());
  } else {
    window.history.pushState({}, '', url.toString());
  }
}

function currentIssueValueForCategory(cat) {
  if (!cat) return '';
  var group = form.querySelector('.cf-issue-group--' + cat);
  if (!group) return '';
  var hidden = group.querySelector('input[type="hidden"]');
  return hidden ? (hidden.value || '') : '';
}

function syncDeepLink(mode) {
  if (isApplyingDeepLink) return;

  writeDeepLink({
    cat: currentCategory || '',
    issue: currentIssueValueForCategory(currentCategory),
    faq: chosenReason || ''
  }, mode || 'push');
}

function applyDeepLinkFromUrl() {
  var dl = readDeepLink();
  if (!dl.cat) return;

  isApplyingDeepLink = true;

  // 1) Click category
  var catBtn = form.querySelector('.cf-category-buttons [data-category="' + dl.cat + '"]');
  if (catBtn) catBtn.click();

  // 2) Click issue (after category UI renders)
  setTimeout(function () {
    if (dl.issue) {
      var issueBtn = form.querySelector(
        '.cf-issue-group--' + dl.cat + ' .cf-issue[data-issue="' + dl.issue + '"]'
      );
      if (issueBtn) issueBtn.click();
    }

    // 3) Open a specific FAQ (after issue highlight logic)
    setTimeout(function () {
      if (dl.faq) {
        var faqBtn = form.querySelector('.cf-reason[data-subreason="' + dl.faq + '"]');
        if (faqBtn) {
          chosenReason = dl.faq;
          if (subjectEl) subjectEl.value = faqBtn.getAttribute('data-subject') || '';
          toggleFaq(faqBtn, dl.faq, true, true);
        }
      }

      isApplyingDeepLink = false;
      // keep URL clean/accurate without adding a new history entry
      syncDeepLink('replace');
    }, 0);
  }, 0);
}

// Back/forward buttons should restore state
window.addEventListener('popstate', function () {
  applyDeepLinkFromUrl();
});

  // Labels
  var categoryLabels = {
    delivery: 'Delivery',
    returns:  'Returns',
    orders:   'Ordering',
    payment:  'Payment',
    warranty: 'Warranty',
    business: 'Business'
  };

  // Extra fields driven by main category (not individual FAQ)
  var categoryExtras = {
    delivery: 'order_number',
    returns:  'order_number,product_name,product_serial',
    orders:   'order_number',
    payment:  'payment_method,order_number',
    warranty: 'order_number,related_gear',
    business: ''
  };

  // ==== FAQ LIMITER (caps list to 7 items unless searching) ====
var FAQ_LIMIT = 7;

function applyFaqLimit() {
  // 1. Searching → no limit, show all FAQs, remove all controls
  var term = faqSearchInput ? faqSearchInput.value.trim().toLowerCase() : "";
  if (term.length > 0) {
    form.querySelectorAll('.cf-faq-controls').forEach(el => el.remove());
    form.querySelectorAll('.cf-reason').forEach(btn => btn.style.display = '');
    return;
  }

  // 2. Remove ALL "view more" controls globally every time
  form.querySelectorAll('.cf-faq-controls').forEach(el => el.remove());

  // 3. Apply limit to each visible subgroup
  form.querySelectorAll('.cf-subgroup:not(.cf-hidden)').forEach(function (sg) {
var faqs = Array.from(sg.querySelectorAll('.cf-reason:not(.cf-hidden)'));
    if (!faqs.length) return;

    // If 7 or fewer → no limit, no button
    if (faqs.length <= FAQ_LIMIT) {
      faqs.forEach(f => f.style.display = '');
      return;
    }

    // Hide extras
    faqs.forEach(function (f, idx) {
      f.style.display = (idx < FAQ_LIMIT) ? '' : 'none';
    });

    // Build controls
    var controls = document.createElement('div');
    controls.className = 'cf-faq-controls';
    controls.style.padding = '12px 0';
    controls.innerHTML = `
      <button class="cf-faq-view-more" style="display:block;margin:0 auto;">View more</button>
      <button class="cf-faq-view-less" style="display:none;margin:0 auto;">View less</button>
    `;

    // Insert controls AFTER this subgroup
    sg.insertAdjacentElement('afterend', controls);

    // Wire up
    var btnMore = controls.querySelector('.cf-faq-view-more');
    var btnLess = controls.querySelector('.cf-faq-view-less');

    btnMore.addEventListener('click', function () {
      faqs.forEach(f => f.style.display = '');
      btnMore.style.display = 'none';
      btnLess.style.display = 'block';
    });

    btnLess.addEventListener('click', function () {
      faqs.forEach(function (f, idx) {
        f.style.display = (idx < FAQ_LIMIT) ? '' : 'none';
      });
      btnMore.style.display = 'block';
      btnLess.style.display = 'none';
    });
  });
}

  // Small shake on error
  function triggerFormErrorAnimation() {
    form.classList.add('cf-error');
    setTimeout(function () {
      form.classList.remove('cf-error');
    }, 250);
  }

  // Extras helpers
  function clearExtras() {
    form.querySelectorAll('.cf-extra').forEach(function (el) {
      el.classList.add('cf-hidden');
    });
  }

  function applyExtras(extrasString) {
    clearExtras();
    if (!extrasString) return;
    extrasString
      .split(',')
      .map(function (s) { return s.trim(); })
      .forEach(function (key) {
        if (!key) return;
        var block = form.querySelector('.cf-extra--' + key.replace(/[^a-z0-9_]/gi, ''));
        if (block) block.classList.remove('cf-hidden');
      });
  }

  function applyExtrasForCategory(cat) {
    applyExtras(categoryExtras[cat] || '');
  }

  // Hide + reset all issue groups
  function hideAllIssueGroups() {
    issueGroups.forEach(function (g) {
      g.classList.add('cf-hidden');
      g.classList.remove('cf-issue-visible');

      g.querySelectorAll('.cf-issue').forEach(function (btn) {
        btn.classList.remove('is-active');
      });

      var notice     = g.querySelector('.cf-issue-notice');
      var noticeText = g.querySelector('.cf-issue-notice__text');
      if (notice) {
        notice.classList.add('cf-hidden');
        notice.classList.remove('is-visible');
      }
      if (noticeText) noticeText.textContent = '';

      var hidden = g.querySelector('input[type="hidden"]');
      if (hidden) hidden.value = '';
    });
  }

  // Reset highlighted FAQ (question + answer)
  function resetFaqHighlight() {
    if (highlightedFaqBtn) {
      highlightedFaqBtn.classList.remove('cf-faq-highlight');
      highlightedFaqBtn = null;
    }
    if (highlightedFaqPanel) {
      highlightedFaqPanel.classList.remove('cf-faq-highlight-panel');
      highlightedFaqPanel = null;
    }
  }

  // Reset ALL FAQ accordions (all categories)
  function resetAllFaqPanels() {
    form.querySelectorAll('.cf-reason').forEach(function (faqBtn) {
      faqBtn.setAttribute('aria-expanded', 'false');
      faqBtn.classList.remove('is-open');
    });
    form.querySelectorAll('.cf-faq-inline').forEach(function (panel) {
      panel.classList.remove('is-open', 'cf-faq-highlight-panel');
    });
    resetFaqHighlight();
  }

  function resetFaqToDefaultState() {
  // Close everything + remove highlight classes
  resetAllFaqPanels();

  // Remove any delivery “only show mapped FAQs” hiding
  form.querySelectorAll('.cf-reason').forEach(function (btn) {
    btn.classList.remove('cf-hidden');
    btn.style.display = '';
  });

  // Remove any “view more/less” controls (search wants a clean list)
  form.querySelectorAll('.cf-faq-controls').forEach(function (ctrl) {
    ctrl.remove();
  });
}

  // Copy under "Choose issue"
  var issueCopy = {
    delivery: {
      delayed_delivery: `
          <ul>
            <li>Check your tracking first where possible.</li>
            <li>If there’s no movement for 48 hours or the delivery date has passed, fill out the form below and we’ll investigate.</li>
          </ul>
      `,
      missing_items: `
       <ul>
        <li>Check your order confirmation and packing slip first.</li>
        <li>Some orders ship in more than one parcel.</li>
        <li>Fill out the form below within 48 hours if something’s missing and we’ll investigate.</li>
        <li>Claims must be reported within 7 days of delivery.</li>
      </ul>
      `,
      damaged_items: `
      <ul>
        <li>Keep all packaging and take clear photos of the box, labels, and damage.</li>
        <li>Fill out the form below and attach the photos so we can resolve it quickly.</li>
        <li>Claims must be reported within 7 days of delivery.</li>
      </ul>
      `,
      delivered_no_parcel: `
      <p>Check safe places, neighbours, reception or communal areas, and the delivery photo first. If it's not there:</p>
        <ol>
          <li>Download this <a target="_blank" href="https://esportsgear.sharepoint.com/:b:/s/external/IQBiCajLTgvzQIFFQzFVFuJZAXETuhk1Z8PvAn85Bw4MCwg?e=g1DLeV">printable denial receipt form</a>.</li>
          <li>Print it out, then sign and date it. </li>
          <li>Take a clear photo of the signed form with your phone.</li>
          <li>Attach the photo to the contact form below. JPG, PNG, or PDF is fine.</li>
          <li>Complete the rest of the contact form and submit it. </li>
          <li>We’ll investigate with the courier and get back to you as soon as possible.</li>
        </ol>
      `,
      change_address: `
      <ul>
        <li>Address changes are only possible before dispatch and usually only for small typos.</li>
        <li>If the address is completely different, for security we’ll cancel and refund the order so you can place it again with the correct details.</li>
      </ul>
        `,
      other: `
      <ul>
        <li>If your delivery issue doesn’t fit the options above, give us a short summary in the message field.</li>
        <li>Including your order number and any tracking links helps us get straight to the important details.</li>
      </ul>
      `
    },
    returns: {
      changed_mind:
      `<ul>
        <li>You have 30 days from delivery to request a return.</li>
        <li><strong>Important:</strong> The item must be unused, in “as new” condition, and in its original packaging. Damaged or incomplete items may be subject to a re-stocking fee (read the FAQ section to the right/below on this page).</li>
      </ul>`,
      faulty_item:
        '<strong>Important:</strong> Before submitting this return, please check our simple <a href="https://esportsgear.uk/pages/troubleshooting" target="_blank">Troubleshooting Guide</a> for fixes for common issues. This can save you a lot of time!',
      other:
        'If your return query doesn’t fit the options above, give us a short summary. Including your order number and whether the item has been used will help us advise the next steps.'
    },
    orders: {
      change_order:
        'We can usually change your order if it hasn’t been picked or dispatched yet. Tell us exactly what you’d like to change (items, quantities or address) and we’ll confirm what’s possible.',
      cancel_order:
        'If your order hasn’t shipped yet, we can often cancel it in full. Once it’s been dispatched, it’s usually treated as a standard return instead. Include your order number so we can check the status quickly.',
      stock_issue:
        'If an item is out of stock or delayed, we can look at alternatives, partial shipping or a refund for that line. Let us know if you’d prefer to wait, swap to something similar, or cancel the affected item.',
      other:
        'If your order question doesn’t match the options above, describe what’s happened and what you’re hoping to do (for example change items, combine orders, or update details).'
    },
    payment: {
      payment_taken_no_order:
        'Sometimes banks reserve funds even when an order fails. These “pending” charges usually drop off automatically after a few working days. If you have a transaction but no order confirmation, tell us the time, amount and payment method so we can double-check.',
      refund_question:
        'Refunds are usually processed on our side quickly, but banks and payment providers can take several working days to show them on your account. Include your order number and when we confirmed the refund so we can review the status.',
      pay_later_options:
        'Pay-later and finance options are handled by providers like Klarna or your card issuer. If there’s an issue with instalments or due dates, they may need to help first, but we can confirm order and refund status at our end.',
      other:
        'For any other payment issue, include the order number (if you have one), the amount, payment method and any reference shown on your statement. That gives us the best chance of finding it quickly.'
    },
    warranty: {
      doa:
        'If your product arrived not working (DOA), we’ll usually look to repair, replace or refund depending on the item and how long it has been since delivery. Describe the fault and any troubleshooting you’ve tried so far.',
      fault_after_use:
        'Faults that appear over time are normally handled under the manufacturer’s warranty. Tell us when you bought the item, what’s going wrong now and whether it’s intermittent or constant. We may ask for photos or a short video.',
      replacement_before_return:
        'We’re generally not able to ship an advance replacement before receiving the faulty item, but once it’s back and inspected we work quickly to repair or replace it. If downtime is critical, mention this and we’ll see what options exist.',
      other:
        'For any other warranty question, give us a brief overview of the product, when you bought it and what’s happening. We’ll advise whether it’s likely to be covered and what the next steps are.'
    },
    business: {
      bulk_order:
        'For bulk or team orders, include a rough idea of quantities, which products you’re interested in and your timeframe. We can then check stock, pricing and possible discounts before coming back to you.',
      reseller:
        'If you’re enquiring about a reseller or trade account, tell us a bit about your business (name, location, sales channels and product focus). Our team will review and let you know if we can offer trade pricing.',
      sponsorship:
        'For sponsorship or partnership requests, include links to your main channels, audience size and any relevant stats or examples. We review proposals periodically and will get back to you if there’s a good fit.',
      other:
        'For any other business enquiry, give us a short summary of what you have in mind and how we can contact you. The more specific you can be, the easier it is for us to route it to the right person.'
    }
  };

  var detailsPlaceholder = {
    delivery: {
      delivered_no_parcel:
        'Tell us what happened, including where tracking says it was delivered and your order number.',
      change_address:
        'Tell us the correct delivery address and your order number so we can update or advise next steps.',
      delayed_delivery:
        'Tell us what’s happened with your delivery, including order number and any tracking info.',
      missing_items:
        'Tell us which items are missing and what should have been in the parcel.',
      damaged_items:
        'Describe the damage and mention if you have photos of the box, labels and item.',
      other:
        'Describe your delivery issue and include your order number if you have one.'
    },
    returns: {
      changed_mind:
        'Tell us what you’d like to return, when it was delivered and whether it has been used.',
      faulty_item:
        'What’s wrong with your gear? Provide as much detail on the issue as possible so we can best help you*',
      other:
        'Tell us about your return query and what outcome you’re hoping for.'
    },
    orders: {
      change_order:
        'Tell us what you’d like to change (items, quantities or address), plus your order number.',
      cancel_order:
        'Tell us which order you’d like to cancel and whether the parcel has already shipped.',
      stock_issue:
        'Tell us which item is affected and whether you’d prefer to wait, swap or cancel it.',
      other:
        'Describe your order question and what you’re trying to do.'
    },
    payment: {
      payment_taken_no_order:
        'Tell us the time, amount and payment method shown on your statement.',
      refund_question:
        'Tell us your order number, refund amount and when we confirmed the refund.',
      pay_later_options:
        'Describe the pay-later/finance issue and which provider you’re using.',
      other:
        'Tell us about your payment issue, including any reference shown on your statement.'
    },
    warranty: {
      doa:
        'Describe the fault, when the product arrived and any troubleshooting you’ve tried.',
      fault_after_use:
        'Tell us when you bought the item, what fault has appeared and how often it happens.',
      replacement_before_return:
        'Tell us about the fault and why a replacement before return would help.',
      other:
        'Describe your warranty question and what you’d like to happen next.'
    },
    business: {
      bulk_order:
        'Tell us roughly how many units you need, which products and your timeframe.',
      reseller:
        'Tell us about your business (name, location, channels) and which brands you’re interested in.',
      sponsorship:
        'Share links to your main channels, audience size and what you’re looking for.',
      other:
        'Describe your business enquiry and how we can help.'
    }
  };

  // Map category + issue → relevant FAQ data-subreason
  var issueToFaq = {
    delivery: {
      delayed_delivery: [
        'del_where',
        'del_times',
        'del_tracking_delay',
        'del_why_delayed',
        'del_rm_tracking'
      ],
      missing_items: [
        'del_missing_item',
        'del_split'
      ],
      damaged_items: [
        'del_damaged_redirect'
      ],
      delivered_no_parcel: [
        'del_delivered_no_parcel',
        'del_where',
        'del_missed'
      ],
      change_address: [
        'del_change_address',
        'del_return_to_sender',
        'del_times'
      ],
      other: [
        'del_times',
        'del_couriers',
        'del_notifications'
      ]
    },
    returns: {
      changed_mind: 'ret_mind',
      faulty_item: 'ret_serial_number',
      other: 'ret_return'
    },
    orders: {
      change_order: 'orders_change',
      cancel_order: 'orders_cancel',
      orders_unfulfilled: 'orders_unfulfilled',
      orders_refunded: 'orders_refunded'
    },
    payment: {
      payment_taken_no_order: 'pay_taken',
      refund_question: 'pay_refund',
      other: 'pay_surcharge'
    },
    warranty: {
      doa:                       'ret_faulty_arrival',
      fault_after_use:           'ret_faulty_later',
      replacement_before_return: 'ret_replacement',
      other:                     'ret_faulty_later'
    },
    business: {
      bulk_order:  'biz_bulk',
      reseller:    'biz_reseller',
      sponsorship: 'biz_sponsorship',
      other:       'biz_other'
    }
  };

  // FAQ inline content (answers only)
  var faqContent = {
    // ORDERS
    orders_discounts: `
      <p>Any active discounts are advertised on the website (banners, product pages, etc.) or sent via our newsletter. We can’t manually apply or backdate discounts if your order falls outside of a promotion period.</p>
    `,
    orders_payment_taken: `
      <p>If a payment attempt fails, your bank may still reserve the funds while it waits for confirmation from our payment provider. Because the transaction doesn’t complete on our side, the bank cancels the pending charge and releases the money back to you. This can take a few working days depending on your bank.</p>
    `,
    orders_change: `
      <p>If you want to swap items or update your delivery address, contact us as soon as possible after placing your order. We can usually make changes before your gear has been picked and handed to the courier. Once you’ve had a shipping confirmation, we can’t amend it.</p>
    `,
    orders_cancel: `
      <p>You can request a cancellation as long as the order hasn’t been collected from our warehouse or had its shipping confirmation issued. If the parcel is already on its way, the easiest option is to refuse the delivery or treat it as a change-of-mind return.</p>
    `,
    orders_oos: `
      <p>If an item you’ve ordered is out of stock, we’ll contact you with an estimated restock time and possible alternatives. You’re always entitled to a refund, either as store credit or back to your original payment method.</p>
    `,
    orders_unfulfilled: `
      <p>Your order shows as “Fulfilled” once the courier has collected your gear from our warehouse. Orders placed later in the day may not be collected until the next working day. Check our Delivery information for more detail on processing times.</p>
    `,
    orders_refunded: `
      <p>Some orders are automatically cancelled and refunded by our fraud-prevention system if suspicious activity is detected. If you believe this is a mistake, contact us and we can review the order and arrange an alternative payment option if appropriate.</p>
    `,

    // PAYMENTS
    pay_surcharge: `
      <p>No, we don’t add extra fees for paying by card or PayPal. The total you see at checkout (including shipping) is what you’ll pay, without hidden payment surcharges.</p>
    `,
    pay_when: `
      <p>For card and PayPal payments, the charge is taken when you complete checkout. For “pay later” options like Klarna, your payment date follows their schedule (for example, a set number of days after the order has shipped).</p>
    `,
    pay_taken: `
      <p>If a payment attempt fails, your bank may temporarily reserve funds while expecting confirmation from our payment provider. Because the transaction is declined on our side, the pending amount is released back to your account. This can take several working days depending on your bank.</p>
    `,
    pay_saved: `
      <p>We don’t store your card details on our website. Payments are processed securely through providers such as PayPal and Shopify Payments, which handle your sensitive information according to their own security and privacy standards.</p>
    `,
    pay_refund: `
      <p>A common reason is when PayPal or your bank can’t fully confirm your billing details, so they automatically refund the transaction instead of completing it. Once refunded, the money returns to your account according to your bank or PayPal’s timescales.</p>
    `,
    pay_confirmed: `
      <p>A confirmed PayPal address is an extra fraud-prevention measure. It helps verify that the card being used belongs to you, and we only ship PayPal orders to confirmed addresses to help protect both you and us against fraud.</p>
    `,
    pay_cancel_refund: `
      <p>Once we confirm a cancellation, we start processing your refund right away. In most cases this appears back in your account within around three to four working days, although some banks can take longer. If the order has already shipped, we’ll need to treat it as a return instead.</p>
    `,

    // DELIVERY
    del_cutoff: `
      <p>Order before 4pm Monday–Friday for same-day dispatch on Express Delivery.</p>
      <p>Orders placed after the cut-off ship the next working day.</p>
    `,
    del_no_express: `
      <p>Some items ship from specific warehouses or suppliers where Express Delivery isn’t supported. In these cases, checkout will only show the services available for that item.</p>
    `,
    del_times: `
      <p>Express Delivery aims for the next working day if you order before 4pm.</p>
      <p>Standard delivery usually arrives within 2 to 3 working days.</p> 
      <p>Free delivery within 4 to 5 working days.</p> 
      <p>Delays can happen due to weather, courier backlogs, routing changes, or peak demand.</p>
    `,
    del_outside_uk: `
      <p>Right now we focus on serving customers within the UK so we can offer better stock levels, pricing and support. International shipping isn’t available yet, but it’s something we may explore in future.</p>
    `,
    del_weekend: `
      <p>Not currently. Deliveries are made Monday–Friday only.</p>
    `,
    del_notifications: `
      <p>Yes — you’ll receive:</p>
      <ul>
        <li>A dispatch email when your gear leaves our warehouse</li>
        <li>A second notification when tracking is added</li>
        <li>Updates directly from the courier (SMS/email) if provided</li>
      </ul>   
    `,
    del_where: `
      <p>Once your order is marked “Shipped,” it’s with the courier.</p> 
      <p>Tracking usually updates within a few hours but can take up to 24 hours.</p> 
      <p>Tracking is only available if you paid for a tracked delivery service.</p> 
      <p>Please allow 1 to 2 working days after the expected delivery date for delays.</p>
      <p>If it’s still not arrived after that, fill out the contact form on this page.</p>
    `,
    del_tracking_delay: `
      <p>Tracking often updates in batches. It’s normal for it to remain unchanged for a few hours — especially overnight. If it hasn’t updated for 48 hours, contact us so we can check with the courier</p>
    `,
    del_rm_tracking: `
      <p>Royal Mail sends you tracking directly via email or text (check your spam/junk folder).</p> 
      <p>It can take 1 to 2 days for them to send tracking after they receive your parcel.</p> 
      <p>This delay is normal and doesn’t mean your order hasn’t shipped.</p> 
      <p>If you still haven’t received tracking after 2 days, fill out the contact form on this page.</p>
    `,
    del_couriers: `
      <p>We mainly use DPD for larger parcels and Royal Mail for smaller items such as skates and grips. Depending on the shipment, we may also work with carriers like FedEx (TNT), UPS or EVRi.</p>
    `,
    del_split: `
      <p>Most orders ship in a single parcel, but if items come from different warehouses you may receive multiple deliveries. We’ll let you know if this happens — there’s no extra cost.</p>
    `,
    del_missed: `
      <p>Couriers will usually attempt redelivery on the next working day. You can also use the calling card, email or SMS to rearrange delivery.</p>
    `,
    del_missing_item: `
      <p>If something is missing, please contact us within 48 hours of delivery. Our warehouses use camera and weight checks to confirm what was packed, so we can investigate quickly and resolve it for you.</p>
    `,
    del_delivered_no_parcel: `
      <p>If tracking shows “Delivered” but you don’t have the parcel, first check safe places, neighbours and anyone else at your address who might have accepted it. Couriers sometimes leave parcels in secure locations.</p>
      <p>If you still can’t find it after checking locally, contact us and we’ll open an investigation with the courier.</p>
    `,
    del_return_to_sender: `
      <p>“Return to Sender” usually means the courier couldn’t complete delivery, the address was incomplete, or the parcel was held too long at a pickup point.</p>
      <p>Once it arrives back with us, we’ll contact you to confirm whether you’d like it re-sent (if possible) or refunded.</p>
    `,
    del_change_address: `
      <p>We can update the delivery address only before your order is packed and collected by the courier. Once it’s been handed over, we can’t guarantee any changes.</p>
      <p>If you need to change the address, contact us as soon as possible with your order number and the correct details.</p>
    `,
    del_why_delayed: `
      <p>Delays can happen due to weather, courier backlogs, routing changes, or peak demand. Tracking updates are sometimes delayed, even while the parcel is still moving.</p>
      <p>If your tracking hasn’t updated for 48 hours or your delivery is past the estimated date, fill out the contact form on this page.</p>
    `,
    del_damaged_redirect: `
      <p>If your item has arrived damaged, this is handled under our <strong>Returns &amp; Warranty</strong> process rather than Delivery.</p>
      <p>Please choose the <strong>Returns</strong> subject and then select <strong>“Item arrived faulty”</strong> so we can resolve this for you as quickly as possible.</p>
      <p>If possible, include photos of the packaging, shipping label and the damaged item when submitting your request - it helps us process replacements much faster.</p>
    `,

    // RETURNS
    ret_return: `
      <p>Select the relevant reason for return and complete the form with your details.</p>
      <p>If it’s a changed mind return, you’ll receive an automated email with instructions within 5 minutes. If you don’t see it, check your spam, junk, or Promotions folder.</p>
      <p>If it’s a faulty item, we aim to reply within 48 hours. Replies may take slightly longer during busy periods.</p>
    `,
    ret_cost: `
      <p>If a product arrives faulty, we’ll normally arrange the return and replacement at no extra cost, subject to inspection. For change-of-mind returns, you’ll need to cover the cost of sending the item back to us.</p>
    `,
    ret_mind: `
      <p>You have 30 days from delivery to request a return.</p>
      <p>The item must be unused, in “as new” condition, and in its original packaging (read: <a href="https://esportsgear.uk/pages/returns-policy" target"_blank">Returns Policy</a>).</p>
      <p>If approved, you can choose a refund, an exchange for an in-stock item, or store credit.</p>
      <p>You’ll need to pay for return shipping.</p>
      <p>Damaged packaging or missing accessories? We may apply a re-stocking fee.</p>
      <p>If your item meets these conditions, fill out the form below…</p>
    `,
    ret_serial_number: `
      <p>Depending on the product, it’s usually located on the base of the item or on the product’s package.</p>
      <p>For headsets, it can be on or inside the earcup.</p>
      <p>If you can’t find it, a simple google search can help (e.g. “serial number location for [insert product name & model]”).</p>
    `,
    ret_faulty_arrival: `
      <p>We treat this as “Dead On Arrival” within the first 30 days. Contact us so we can help troubleshoot and confirm the fault. If a fault is confirmed, you can usually choose a replacement, refund or store credit.</p>
    `,
    ret_faulty_later: `
      <p>If your gear develops a fault after the initial DOA period but is still within the manufacturer’s warranty, you’re normally entitled to a repair or replacement, depending on the product. Fill in the returns form and we’ll guide you through the warranty process.</p>
    `,
    ret_replacement: `
      <p>We’re not able to offer advanced replacements. As soon as we receive the item and confirm the fault, we’ll arrange a replacement or other agreed resolution and ship it out as quickly as possible.</p>
    `,

    // BUSINESS
    biz_bulk: `
      <p>If you’re ordering for a team, organisation or event, let us know roughly how many units you’re interested in, which products you have in mind and your timeframe. We can review stock, pricing and possible bulk discounts and get back to you with options.</p>
    `,
    biz_reseller: `
      <p>Tell us a bit about your business (company name, location, sales channels and the brands you’re interested in). Our team will review your enquiry and let you know if we’re able to offer trade pricing or a reseller arrangement.</p>
    `,
    biz_sponsorship: `
      <p>If you’re a team, creator or organiser looking for sponsorship or a partnership, include links to your main channels, audience size and relevant stats. We review proposals periodically and will get back to you if there’s a good fit.</p>
    `,
    biz_other: `
      <p>For anything else business-related (for example collaborations, corporate gifting or other proposals), give us a brief overview of what you have in mind and how we can contact you, and our team will follow up.</p>
    `
  };

  // Toggle a FAQ row + panel, optional highlight
  function toggleFaq(btn, subreason, forceOpen, highlight) {
    var dataKey = subreason || btn.getAttribute('data-subreason') || null;
    if (!dataKey || !faqContent[dataKey]) return;

    var isOpen     = btn.getAttribute('aria-expanded') === 'true';
    var shouldOpen = (typeof forceOpen === 'boolean') ? forceOpen : !isOpen;

    var panel = btn.nextElementSibling;
    if (!panel || !panel.classList.contains('cf-faq-inline')) {
      panel = document.createElement('div');
      panel.className = 'cf-faq-inline';
      btn.insertAdjacentElement('afterend', panel);
    }

    if (!shouldOpen) {
      btn.setAttribute('aria-expanded', 'false');
      btn.classList.remove('is-open');
      panel.classList.remove('is-open');

      if (btn === highlightedFaqBtn) {
        btn.classList.remove('cf-faq-highlight');
        if (highlightedFaqPanel === panel) {
          panel.classList.remove('cf-faq-highlight-panel');
          highlightedFaqPanel = null;
        }
        highlightedFaqBtn = null;
      }
      return;
    }

    // Open
    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('is-open');
    panel.innerHTML = faqContent[dataKey];
    panel.classList.add('is-open');

    if (highlight) {
      btn.classList.add('cf-faq-highlight');
      panel.classList.add('cf-faq-highlight-panel');
      highlightedFaqBtn   = btn;
      highlightedFaqPanel = panel;
    }
  }

  function getCategoryLabel(cat) {
    if (!cat) return '';
    return categoryLabels[cat] ||
      (cat.charAt(0).toUpperCase() + cat.slice(1));
  }

  function updateDetailsPlaceholder(cat, issueKey) {
    if (!detailsTextarea) return;
    var phGroup = detailsPlaceholder[cat];
    var ph = phGroup && phGroup[issueKey] ? phGroup[issueKey] : 'Details';
    detailsTextarea.placeholder = ph;
  }

  // CATEGORY SELECT
  form.querySelectorAll('.cf-category-buttons [data-category]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var currentCat = btn.getAttribute('data-category');
      currentCategory = currentCat;

      if (successBox) {
        successBox.classList.add('cf-hidden');
      }

      resetAllFaqPanels();

      // REMOVE all global search hiding
        form.querySelectorAll('.cf-reason').forEach(function (faqBtn) {
            faqBtn.classList.remove('cf-hidden');
        });

      // Enable search when category selected
      if (faqSearchInput) {
        faqSearchInput.removeAttribute('disabled');
        faqSearchInput.value = '';
      }

      chosenReason = null;

      if (faqTitle) {
        faqTitle.textContent = getCategoryLabel(currentCat) + ' FAQs';
      }

      applyExtrasForCategory(currentCat);

      // Active state
      form.querySelectorAll('.cf-category-buttons [data-category]').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });

      // Show relevant subgroup
      form.querySelectorAll('.cf-subgroup').forEach(function (sg) {
        sg.classList.add('cf-hidden');
      });

      // remove all view-more/less blocks
      form.querySelectorAll('.cf-faq-controls').forEach(function(ctrl){
        ctrl.remove();
      });

      form.querySelectorAll('.cf-reason').forEach(f => f.style.display = '');
      var subgroup = form.querySelector('.cf-subgroup--' + currentCat);
      if (subgroup) {
        subgroup.classList.remove('cf-hidden');
        applyFaqLimit();
      }

      // Deep link: step 1 (category only) – clear issue+faq
      if (!isApplyingDeepLink) {
        chosenReason = null;
        writeDeepLink({ cat: currentCategory, issue: '', faq: '' }, 'push');
      }

      // Issue group
      hideAllIssueGroups();

      var issueGroup = form.querySelector('.cf-issue-group--' + currentCat);
      if (issueGroup) {
        issueGroup.classList.remove('cf-hidden');
        void issueGroup.offsetWidth;
        issueGroup.classList.add('cf-issue-visible');

        if (detailsStep) {
          detailsStep.classList.add('cf-hidden');
          detailsStep.classList.remove('cf-visible');
        }
      } else {
        // Category with no second question → show details
        if (detailsStep) {
          detailsStep.classList.remove('cf-hidden');
          void detailsStep.offsetWidth;
          detailsStep.classList.add('cf-visible');
        }
      }
      syncConditionalFieldSubmission();
    });
  });

  // FAQ BUTTON CLICK (accordion)
  form.querySelectorAll('.cf-reason').forEach(function (btn) {
    btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') || 'false');

    btn.addEventListener('click', function () {
      var subject = btn.getAttribute('data-subject') || '';
      chosenReason = btn.getAttribute('data-subreason') || null;
      if (subjectEl) subjectEl.value = subject;

      // Deep link: step 3 (category + issue + faq)
      syncDeepLink('push');

      // toggleFaq handles open/close; highlight only if already recommended
      toggleFaq(btn, chosenReason, null, btn === highlightedFaqBtn);
    });
  });

  // GLOBAL FAQ SEARCH
  if (faqSearchInput) {
    faqSearchInput.addEventListener('input', function () {
      var term = faqSearchInput.value.trim().toLowerCase();

      if (term.length > 0) {

    // If the user starts searching, clear any highlighted/forced-open FAQ state
    if (term.length > 0) {
      resetFaqToDefaultState();
    }

        // Show ALL subgroups while searching
        form.querySelectorAll('.cf-subgroup').forEach(function (sg) {
          sg.classList.remove('cf-hidden');
        });
      } else if (currentCategory) {
        // Restore chosen category subgroup
        form.querySelectorAll('.cf-subgroup').forEach(function (sg) {
          sg.classList.add('cf-hidden');
        });

        var subgroup = form.querySelector('.cf-subgroup--' + currentCategory);
        if (subgroup) subgroup.classList.remove('cf-hidden');
      }

      applyFaqLimit();

      // Filter all FAQs across all categories
      form.querySelectorAll('.cf-reason').forEach(function (btn) {
        var txtEl = btn.querySelector('.cf-faq-question-text');
        var questionText = txtEl ? txtEl.textContent.toLowerCase() : '';

        if (!term || questionText.includes(term)) {
          btn.classList.remove('cf-hidden');
        } else {
          btn.classList.add('cf-hidden');
        }
      });
    });
  }

  // ISSUE BUTTONS (all categories)
  issueGroups.forEach(function (group) {
    var cat        = group.getAttribute('data-category');
    var buttons    = group.querySelectorAll('.cf-issue');
    var hidden     = group.querySelector('input[type="hidden"]');
    var notice     = group.querySelector('.cf-issue-notice');
    var noticeText = group.querySelector('.cf-issue-notice__text');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-issue') || '';

        if (successBox) {
          successBox.classList.add('cf-hidden');
        }

          // Per-question form behaviour (attachments)
          // Defaults: hide unless explicitly needed
          if (cat === 'delivery') {
            if (val === 'delivered_no_parcel') {
              // keep existing behaviour + do NOT change label here
              setAttachmentsMode('required');
            } else if (val === 'damaged_items') {
              // ONLY this one gets the new label + required
              setAttachmentsMode('required', 'Attach photos of damage*');
            } else {
              setAttachmentsMode('hide');
            }
          } else {
            setAttachmentsMode('hide');
          }

        // Summary chip
        if (summaryEl && currentCategory) {
          var catLabel = getCategoryLabel(currentCategory);
          summaryEl.textContent =
            'You’re contacting us about: ' + catLabel + ' · ' + btn.textContent.trim();
        }

        if (hidden) {
          hidden.value = val;
        }

        // Deep link: step 2 (category + issue) – clear faq
        if (!isApplyingDeepLink) {
          chosenReason = null;
          writeDeepLink({ cat: currentCategory, issue: val, faq: '' }, 'push');
        }

        // Active state within this group
        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });

        // Notice text
        var msg = (issueCopy[cat] && issueCopy[cat][val]) ? issueCopy[cat][val] : '';
        if (notice && noticeText) {
          if (msg) {
            // Allow simple HTML (lists, line breaks) in notices
            noticeText.innerHTML = msg;
            notice.classList.remove('cf-hidden');
            void notice.offsetWidth;
            notice.classList.add('is-visible');
          } else {
            noticeText.innerHTML = '';
            notice.classList.remove('is-visible');
            notice.classList.add('cf-hidden');
          }
          updateDetailsPlaceholder(cat, val);
        }

          // Order number required for all issues except "other"
          if (orderNumberInput) {
            if (val && val !== 'other') {
              orderNumberInput.placeholder = 'Your EG Order Number (EGXXXXX)*';
              orderNumberInput.setAttribute('required', 'required');
            } else {
              orderNumberInput.placeholder = 'Order number (if you have one)';
              orderNumberInput.removeAttribute('required');
            }
          }

          // Returns: always collect product name + serial number
            if (cat === 'returns') {
              var isFaulty = (val === 'faulty_item');
              var isChangedMind = (val === 'changed_mind');

              // Ensure product blocks are visible for ALL returns issues
              if (productNameBlock)   productNameBlock.classList.remove('cf-hidden');
              if (productSerialBlock) productSerialBlock.classList.remove('cf-hidden');

              // Always required for returns
              if (productNameInput)   productNameInput.setAttribute('required', 'required');
              if (productSerialInput) productSerialInput.setAttribute('required', 'required');

              // Fault timing ONLY for faulty item
              if (faultTimingBlock) faultTimingBlock.classList.toggle('cf-hidden', !isFaulty);

              if (faultTimingSelect) {
                if (isFaulty) {
                  faultTimingSelect.setAttribute('required', 'required');
                } else {
                  faultTimingSelect.removeAttribute('required');
                  faultTimingSelect.value = '';
                }
              }

              // Returns: "Changed my mind" return reason dropdown
              if (returnReasonBlock) {
                returnReasonBlock.classList.toggle('cf-hidden', !isChangedMind);
              }

              if (returnReasonSelect) {
                if (isChangedMind) {
                  returnReasonSelect.setAttribute('required', 'required');
                } else {
                  returnReasonSelect.removeAttribute('required');
                  returnReasonSelect.value = '';
                }
              }

              // Attachments: optional prompt for faulty only
              if (isFaulty) {
                setAttachmentsMode('optional', 'Attach a photo/video of the issue (max 25MB each)');
              }
            } else {
              // Not returns: ensure these can't block submission while hidden
              if (productNameInput)   { productNameInput.removeAttribute('required'); productNameInput.value = ''; }
              if (productSerialInput) { productSerialInput.removeAttribute('required'); productSerialInput.value = ''; }
              if (faultTimingSelect)  { faultTimingSelect.removeAttribute('required'); faultTimingSelect.value = ''; }
            }

          // Delivery: address change fields (only for change_address)
          if (addressChangeBlock) {
            var isAddrChange = (cat === 'delivery' && val === 'change_address');

            addressChangeBlock.classList.toggle('cf-hidden', !isAddrChange);

            [updatedAddress1, updatedCity, updatedPostcode].forEach(function (el) {
              if (!el) return;
              if (isAddrChange) el.setAttribute('required', 'required');
              else {
                el.removeAttribute('required');
                el.value = '';
              }
            });
          }

        // Show/hide extra prevention checkboxes for "Tracking says delivered but no parcel"
        if (deliveredChecksBlock) {
          if (cat === 'delivery' && val === 'delivered_no_parcel') {
            deliveredChecksBlock.classList.remove('cf-hidden');
          } else {
            deliveredChecksBlock.classList.add('cf-hidden');
            // Reset checkboxes when not needed
            deliveredChecksBlock.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
              cb.checked = false;
            });
          }
        }

        // FAQ highlight logic
        var map   = issueToFaq[cat] || null;
        var entry = map ? map[val] : null;

        resetFaqHighlight();

        if (cat === 'delivery') {
          var subgroupEl = form.querySelector('.cf-subgroup--' + cat);

        if (subgroupEl) {
          subgroupEl.querySelectorAll('.cf-reason').forEach(function (faqBtn) {
            // fully reset + close
            faqBtn.classList.remove('cf-hidden', 'cf-faq-highlight', 'is-open');
            faqBtn.setAttribute('aria-expanded', 'false');

            var pnl = faqBtn.nextElementSibling;
            if (pnl && pnl.classList.contains('cf-faq-inline')) {
              pnl.classList.remove('is-open', 'cf-faq-highlight-panel');
            }

            // then hide everything
            faqBtn.classList.add('cf-hidden');
          });
        }

          var relevantFaqs = [];
          if (Array.isArray(entry)) {
            relevantFaqs = entry;
          } else if (typeof entry === 'string' && entry) {
            relevantFaqs = [entry];
          }

          if (subgroupEl && relevantFaqs.length) {
            relevantFaqs.forEach(function (subreasonId, index) {
              var target = subgroupEl.querySelector(
                '.cf-reason[data-subreason="' + subreasonId + '"]'
              );
              if (!target) return;

              // Show this FAQ row
              target.classList.remove('cf-hidden');

              // Primary FAQ: highlight + auto-open
              if (index === 0) {
                chosenReason = subreasonId;
                if (subjectEl) {
                  subjectEl.value = target.getAttribute('data-subject') || '';
                }

                toggleFaq(target, subreasonId, true, true);
              }
            });
          } else if (subgroupEl) {
            // Fallback: show all FAQs for Delivery
            subgroupEl.querySelectorAll('.cf-reason').forEach(function (faqBtn) {
              faqBtn.classList.remove('cf-hidden');
            });
          }
        } else {
          // Non-delivery: single mapped FAQ
          var subreason = entry;

          if (subreason) {
            var target = form.querySelector(
              '.cf-subgroup--' + cat + ' .cf-reason[data-subreason="' + subreason + '"]'
            );
            if (target) {
              chosenReason = subreason;
              if (subjectEl) {
                subjectEl.value = target.getAttribute('data-subject') || '';
              }
              toggleFaq(target, subreason, true, true);
            }
          }
        }

        if (cat === 'delivery') {
          applyFaqLimit();
        }

        // Show details step
        if (detailsStep) {
          detailsStep.classList.remove('cf-hidden');
          void detailsStep.offsetWidth;
          detailsStep.classList.add('cf-visible');
        }
       syncConditionalFieldSubmission();
      });
    });
  });

  // SUBMIT VALIDATION
  form.addEventListener('submit', function (e) {
    var submitBtn = form.querySelector('.cf-submit');

    if (isUploadingAttachments) {
      e.preventDefault();
      return;
    }

    isUploadingAttachments = true;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Uploading...';
    }

    // Must pick a FAQ (subject)
    if (!chosenReason) {
      e.preventDefault();
      resetSubmitLock();
      triggerFormErrorAnimation();
      alert('Please choose what your message is about first (using the FAQs on the right).');
      return;
    }

    // Must pick a specific issue in the chosen category
    var selectedIssueValue = null;
    if (currentCategory) {
      var group = form.querySelector('.cf-issue-group--' + currentCategory);
      if (group) {
        var hidden = group.querySelector('input[type="hidden"]');
        if (!hidden || !hidden.value) {
          e.preventDefault();
          resetSubmitLock();
          triggerFormErrorAnimation();
          alert('Please choose your ' + currentCategory + ' issue.');
          return;
        }
        selectedIssueValue = hidden.value;
      }
    }

   // Require order number for all issues except "other"
    var issueVal = '';
    if (currentCategory) {
      var group2 = form.querySelector('.cf-issue-group--' + currentCategory);
      var hidden2 = group2 ? group2.querySelector('input[type="hidden"]') : null;
      issueVal = hidden2 ? (hidden2.value || '') : '';
    }

    if (issueVal && issueVal !== 'other') {
      if (!orderNumberInput || !orderNumberInput.value.trim()) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please enter your EG order number.');
        if (detailsStep) {
          detailsStep.classList.remove('cf-hidden');
          void detailsStep.offsetWidth;
          detailsStep.classList.add('cf-visible');
        }
        return;
      }
    }

    // Basic name + email validation
    var name  = form.querySelector('input[name="contact[name]"]');
    var email = form.querySelector('input[name="contact[email]"]');

    if (!name.value.trim() || !email.value.trim()) {
      e.preventDefault();
      resetSubmitLock();
      triggerFormErrorAnimation();
      alert('Please enter your name and email.');
      if (detailsStep) {
        detailsStep.classList.remove('cf-hidden');
        void detailsStep.offsetWidth;
        detailsStep.classList.add('cf-visible');
      }
      return;
    }

    // Confirm email matches
    if (emailConfirm) {
      syncEmailConfirmValidity();
      var emailConfirmVal = emailConfirm.value.trim();
      if (!emailConfirmVal) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please confirm your email address.');
        if (detailsStep) {
          detailsStep.classList.remove('cf-hidden');
          void detailsStep.offsetWidth;
          detailsStep.classList.add('cf-visible');
        }
        return;
      }
      if (emailConfirmVal.toLowerCase() !== email.value.trim().toLowerCase()) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        emailConfirm.reportValidity();
        if (detailsStep) {
          detailsStep.classList.remove('cf-hidden');
          void detailsStep.offsetWidth;
          detailsStep.classList.add('cf-visible');
        }
        return;
      }
    }

    // Returns: extra validation for "Gear is faulty"
    if (currentCategory === 'returns' && selectedIssueValue === 'faulty_item') {
      if (!productNameInput || !productNameInput.value.trim()) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please enter the product name.');
        if (detailsStep) {
          detailsStep.classList.remove('cf-hidden');
          void detailsStep.offsetWidth;
          detailsStep.classList.add('cf-visible');
        }
        return;
      }

      if (!productSerialInput || !productSerialInput.value.trim()) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please enter the product serial number.');
        if (detailsStep) {
          detailsStep.classList.remove('cf-hidden');
          void detailsStep.offsetWidth;
          detailsStep.classList.add('cf-visible');
        }
        return;
      }

      if (!faultTimingSelect || !faultTimingSelect.value) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please choose when the fault occurred.');
        if (detailsStep) {
          detailsStep.classList.remove('cf-hidden');
          void detailsStep.offsetWidth;
          detailsStep.classList.add('cf-visible');
        }
        return;
      }
    }

    // Returns: require product name + serial number
    if (currentCategory === 'returns') {
      if (!productNameInput || !productNameInput.value.trim()) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please enter the product name.');
        if (detailsStep) {
          detailsStep.classList.remove('cf-hidden');
          void detailsStep.offsetWidth;
          detailsStep.classList.add('cf-visible');
        }
        return;
      }

      if (!productSerialInput || !productSerialInput.value.trim()) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert('Please enter the product serial number.');
        if (detailsStep) {
          detailsStep.classList.remove('cf-hidden');
          void detailsStep.offsetWidth;
          detailsStep.classList.add('cf-visible');
        }
        return;
      }

      if (selectedIssueValue === 'changed_mind') {
        if (!returnReasonSelect || !returnReasonSelect.value) {
          e.preventDefault();
          resetSubmitLock();
          triggerFormErrorAnimation();
          alert('Please select a reason for returning your gear.');
          if (detailsStep) {
            detailsStep.classList.remove('cf-hidden');
            void detailsStep.offsetWidth;
            detailsStep.classList.add('cf-visible');
          }
          return;
        }
      }
    }

    // Extra validation for "Tracking says delivered but no parcel"
          if (
        currentCategory === 'delivery' &&
        (selectedIssueValue === 'delivered_no_parcel' || selectedIssueValue === 'damaged_items')
      ) {
      // 1) Require at least one attachment
      var hasAttachment = false;
      if (attachContainer) {
        var fileInputsAll = attachContainer.querySelectorAll('input[type="file"]');
        fileInputsAll.forEach(function (fi) {
          if (fi.files && fi.files.length > 0) {
            hasAttachment = true;
          }
        });
      }
      if (!hasAttachment) {
        e.preventDefault();
        resetSubmitLock();
        triggerFormErrorAnimation();
        alert(
          selectedIssueValue === 'damaged_items'
            ? 'Please attach photos of the damage.'
            : 'Please attach a clear photo of the signed denial of receipt form.'
        );
        if (detailsStep) {
          detailsStep.classList.remove('cf-hidden');
          void detailsStep.offsetWidth;
          detailsStep.classList.add('cf-visible');
        }
        return;
      }

      // 2) Require all three confirmation checkboxes (ONLY for delivered_no_parcel)
      if (selectedIssueValue === 'delivered_no_parcel' && deliveredChecksBlock) {
        var checkboxes = deliveredChecksBlock.querySelectorAll('input[type="checkbox"]');
        var allChecked = true;
        checkboxes.forEach(function (cb) {
          if (!cb.checked) allChecked = false;
        });
        if (!allChecked) {
          e.preventDefault();
          resetSubmitLock();
          triggerFormErrorAnimation();
          alert('Please tick all confirmation boxes to submit this claim.');
          if (detailsStep) {
            detailsStep.classList.remove('cf-hidden');
            void detailsStep.offsetWidth;
            detailsStep.classList.add('cf-visible');
          }
          return;
        }
      }
    }

        // UPLOAD ATTACHMENTS TO CLOUDFLARE R2
    var fileInputs = attachContainer ? attachContainer.querySelectorAll('input[type="file"]') : [];
    var files = [];

    fileInputs.forEach(function (input) {
      if (input.files && input.files[0]) {
        files.push({
          file: input.files[0],
          input: input
        });
      }
    });

    // LIMIT TO 5 FILES
    if (files.length > 5) {
      e.preventDefault();
      resetSubmitLock();
      alert("You can upload a maximum of 5 files.");
      return;
    }

    if (files.length) {
      e.preventDefault();

      Promise.all(files.map(function (entry) {
        return compressImageFile(entry.file).then(function (finalFile) {
          var fd = new FormData();
          fd.append("file", finalFile);

          return fetch("https://cold-snowflake-6f9d.mike-df4.workers.dev", {
            method: "POST",
            headers: {
              "x-upload-token": "eg_upload_9f8c2d71b44e4b8f9f5e2a6c1d7b33aa"
            },
            body: fd
          })
          .then(function (r) {
            if (!r.ok) {
              return r.text().then(function (txt) {
                throw new Error("Upload failed: " + txt);
              });
            }
            return r.json();
          })
          .then(function (data) {
            if (data && entry.file && entry.file.name) {
              data.name = entry.file.name;
            }
            return data;
          });
        });
      }))
      .then(function (results) {
        var uploadedFiles = results
          .map(function (data) {
            if (!data || !data.url) return null;
            return {
              url: data.url,
              name: data.name || ''
            };
          })
          .filter(Boolean);

        if (!uploadedFiles.length) {
          throw new Error("No upload URLs returned.");
        }

        syncUploadedAttachmentFields(uploadedFiles);

        fileInputs.forEach(function (input) {
          input.value = "";
          input.disabled = true;
        });

        form.submit();
      })
      .catch(function (err) {
        console.error(err);
        resetSubmitLock();
        alert("Attachment upload failed. Please try again.");
      });

      return;
    }

  });

  // ATTACHMENTS (images)
  if (attachContainer) {
    var addMoreBtn  = attachContainer.querySelector('.cf-add-more-files');
    var fileInputs  = attachContainer.querySelector('.cf-attach-inputs');
    var previewArea = attachContainer.querySelector('.cf-attach-preview');

    var MAX_FILE_MB = 25;
    var MAX_IMAGES  = 5;

    var uploadCounter = attachContainer ? attachContainer.querySelector('.cf-upload-count') : null;

    function updateUploadCounter() {
      if (!uploadCounter) return;

      var count = currentCount();
      uploadCounter.textContent = "(" + count + "/" + MAX_IMAGES + " uploaded)";
    }

    function formatSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

function createPreview(file, inputEl) {
  var wrapper = document.createElement('div');
  wrapper.className = 'cf-thumb-wrapper';

  // Preview: image thumbnail OR PDF label
  var isImage = file.type && file.type.startsWith('image/');
  var isPdf   = file.type === 'application/pdf';
  var isVideo = file.type && file.type.startsWith('video/');

  if (isImage) {
    var reader = new FileReader();
    reader.onload = function (e) {
      var img = document.createElement('img');
      img.src = e.target.result;
      img.className = 'cf-attach-thumb';
      wrapper.insertBefore(img, wrapper.firstChild);
    };
    reader.readAsDataURL(file);
  } else if (isPdf) {
    var pdfLabel = document.createElement('div');
    pdfLabel.className = 'cf-attach-pdf';
    pdfLabel.textContent = 'PDF: ' + (file.name || 'document.pdf');
    wrapper.appendChild(pdfLabel);
  } else if (isVideo) {
    var videoLabel = document.createElement('div');
    videoLabel.className = 'cf-attach-pdf';
    videoLabel.textContent = 'VIDEO: ' + (file.name || 'video');
    wrapper.appendChild(videoLabel);
  }

  var sizeEl = document.createElement('div');
  sizeEl.className = 'cf-thumb-size';
  sizeEl.textContent = formatSize(file.size);

  var removeBtn = document.createElement('button');
  removeBtn.type = 'button';
  removeBtn.className = 'cf-remove-thumb';
  removeBtn.innerHTML = '&times;';

  removeBtn.addEventListener('click', function () {
    wrapper.remove();
    inputEl.remove();
    updateUploadCounter();
  });

  wrapper.appendChild(sizeEl);
  wrapper.appendChild(removeBtn);
  previewArea.appendChild(wrapper);
  updateUploadCounter();
}

    function currentCount() {
      return previewArea.querySelectorAll('.cf-thumb-wrapper').length;
    }

    function handleFileSelection(inputEl) {
      inputEl.addEventListener('change', function (e) {
        var file = e.target.files[0];
        if (!file) return;

        // Allow images + PDFs only
        var isImage = file.type && file.type.startsWith('image/');
        var isPdf   = file.type === 'application/pdf';
        var isVideo = file.type && file.type.startsWith('video/');

        if (!isImage && !isPdf && !isVideo) {
          alert('File type not supported. Please upload an image, video, or PDF.');
          inputEl.value = '';
          return;
        }

        if (currentCount() >= MAX_IMAGES) {
        alert('You can upload a maximum of ' + MAX_IMAGES + ' files.');
          inputEl.value = '';
          return;
        }

        if (file.size > MAX_FILE_MB * 1024 * 1024) {
        alert('This file is too large. Max size: ' + MAX_FILE_MB + 'MB.');
          inputEl.value = '';
          return;
        }

        createPreview(file, inputEl);
      });
    }

    // initial file input
    var firstInput = attachContainer.querySelector('.cf-file-input');
    if (firstInput) handleFileSelection(firstInput);
  }

  if (emailInput && emailConfirm) {
    emailInput.addEventListener('input', syncEmailConfirmValidity);
    emailConfirm.addEventListener('input', syncEmailConfirmValidity);
    emailConfirm.addEventListener('blur', syncEmailConfirmValidity);
  }
  
  // --- ON INITIAL PAGE LOAD: hide all subgroups except first one ---
var allSubgroups = form.querySelectorAll('.cf-subgroup');

// Hide every subgroup
allSubgroups.forEach(function (sg) {
  sg.classList.add('cf-hidden');
});

// Show Delivery subgroup by default
var deliveryGroup = form.querySelector('.cf-subgroup--delivery');
if (deliveryGroup) {
  deliveryGroup.classList.remove('cf-hidden');
  applyFaqLimit();
}
applyDeepLinkFromUrl();
setAttachmentsMode('hide');
syncConditionalFieldSubmission();
});
